var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"google-auth-login"},[_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.loginWithGoogle}},[_vm._v("Login with Google")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }